import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'he',
  months: ['ינואר', 'פברואר', 'מרץ', 'אפריל', 'מאי', 'יוני', 'יולי', 'אוגוסט', 'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר'],
  monthsShort: ["ינו'", "פבר'", 'מרץ', 'אפר', 'מאי', 'יוני', 'יולי', "אוג'", "ספט'", "אוק'", "נוב'", "דצמ'"],
  weekdays: ['יום ראשון', 'יום שני', 'יום שלישי', 'יום רביעי', 'יום חמישי', 'יום שישי', 'שבת'],
  weekdaysMin: ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'],
  weekdaysShort: ['ראשון', 'שני', 'שלישי', 'רביעי', 'חמישי', 'שישי', 'שבת'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'HH:mm',
    lts: 'HH:mm:ss',
    L: '‎D.MM.YYYY',
    LL: '‎D בYYYY MMMM',
    'LL-D': 'MMMM YYYY',
    'LL-Y': '‎D בMMMM',
    LLL: '‎D בYYYY MMMM בשעה HH:mm',
    'LLL-Y': '‎D בMMMM בשעה HH:mm',
    LLLL: 'dddd, D בYYYY MMMM בשעה HH:mm',
    'LLLL-Y': 'dddd, D בMMMM בשעה HH:mm',
    l: '‎D.M.YYYY',
    'l-Y': '‎D.M',
    ll: '‎D בYYYY MMM',
    'll-Y': '‎D בMMM',
    'll-D': 'MMM YYYY',
    lll: '‎D בYYYY MMM בשעה HH:mm',
    'lll-Y': '‎D בMMM בשעה HH:mm',
    llll: 'dddd, D בYYYY MMM בשעה HH:mm',
    'llll-Y': 'dddd, D בMMM בשעה HH:mm',
    'll-Y+w': 'ddd, D בMMM',
    'LT+to': '‎H:mm ([GMT]Z[‎])',
    'LLL+to': '‎D בYYYY MMMM בשעה HH:mm ([GMT]Z[‎])',
  },
  meridiem: { am: 'לפנה"צ', pm: 'אחה"צ', AM: 'לפנה"צ', PM: 'אחה"צ' },
  past: {
    y: { one: 'לפני שנה', two: 'לפני שנתיים', many: 'לפני %s שנים', other: 'לפני %s שנים' },
    M: { one: "לפני חד' %s", two: "לפני %s חד'", other: "לפני %s חד'" },
    w: { one: "לפני שב' %s", two: "לפני %s שב'", many: "לפני %s שב'", other: "לפני %s שב'" },
    d: { one: 'לפני יום %s', two: "לפני %s ימ'", other: "לפני %s ימ'" },
    h: { one: "לפני שע' %s", two: "לפני %s שע'", many: "לפני %s שע'", other: "לפני %s שע'" },
    m: { one: "לפני דק' %s", two: "לפני %s דק'", many: "לפני %s דק'", other: "לפני %s דק'" },
    s: { one: "לפני שנ' %s", two: "לפני %s שנ'", many: "לפני %s שנ'", other: "לפני %s שנ'" },
  },
  future: {
    y: { one: 'בעוד שנה', two: 'בעוד שנתיים', many: 'בעוד %s שנים', other: 'בעוד %s שנים' },
    M: { one: "בעוד חד' %s", two: "בעוד %s חד'", other: "בעוד %s חד'" },
    w: { one: "בעוד שב' %s", two: "בעוד %s שב'", many: "בעוד %s שב'", other: "בעוד %s שב'" },
    d: { one: 'בעוד יום %s', two: "בעוד %s ימ'", other: "בעוד %s ימ'" },
    h: { one: "בעוד שע' %s", two: "בעוד %s שע'", many: "בעוד %s שע'", other: "בעוד %s שע'" },
    m: { one: "בעוד דק' %s", two: "בעוד %s דק'", many: "בעוד %s דק'", other: "בעוד %s דק'" },
    s: { one: 'בעוד שניה', two: 'בעוד %s שניות', many: 'בעוד %s שניות', other: 'בעוד %s שניות' },
  },
  pastLong: {
    y: { one: 'לפני שנה', two: 'לפני שנתיים', many: 'לפני %s שנים', other: 'לפני %s שנים' },
    M: { one: 'לפני חודש', two: 'לפני חודשיים', other: 'לפני %s חודשים' },
    w: { one: 'לפני שבוע', two: 'לפני שבועיים', other: 'לפני %s שבועות' },
    d: { one: 'לפני יום', two: 'לפני יומיים', other: 'לפני %s ימים' },
    h: { one: 'לפני שעה', two: 'לפני שעתיים', other: 'לפני %s שעות' },
    m: { one: 'לפני דקה', two: 'לפני %s דקות', other: 'לפני %s דקות' },
    s: { one: 'לפני שנייה', two: 'לפני %s שניות', other: 'לפני %s שניות' },
  },
  futureLong: {
    y: { one: 'בעוד שנה', two: 'בעוד שנתיים', many: 'בעוד %s שנים', other: 'בעוד %s שנים' },
    M: { one: 'בעוד חודש', two: 'בעוד חודשיים', other: 'בעוד %s חודשים' },
    w: { one: 'בעוד שבוע', two: 'בעוד שבועיים', other: 'בעוד %s שבועות' },
    d: { one: 'בעוד יום %s', two: 'בעוד יומיים', other: 'בעוד %s ימים' },
    h: { one: 'בעוד שעה', two: 'בעוד שעתיים', other: 'בעוד %s שעות' },
    m: { one: 'בעוד דקה', two: 'בעוד %s דקות', other: 'בעוד %s דקות' },
    s: { one: 'בעוד שנייה', two: 'בעוד %s שניות', other: 'בעוד %s שניות' },
  },
  abbr: {
    y: { one: '%s שנה', two: 'שנתיים', many: '%s שנים', other: '%s שנים' },
    M: { one: "חד' %s", two: "%s חד'", many: "%s חד'", other: "%s חד'" },
    w: { one: "שב' %s", two: "%s שב'", many: "%s שב'", other: "%s שב'" },
    d: { one: 'יום %s', two: "%s ימ'", many: "%s ימ'", other: "%s ימ'" },
    h: { one: "שע' %s", two: "%s שע'", many: "%s שע'", other: "%s שע'" },
    m: { one: "דק' %s", two: "%s דק'", many: "%s דק'", other: "%s דק'" },
    s: { one: 'שניה %s', two: '%s שניות', many: '%s שניות', other: '%s שניות' },
  },
  full: {
    y: { one: 'שנה', two: 'שנתיים', other: '%s שנים' },
    M: { one: 'חודש', two: 'חודשיים', many: '%s חודשים', other: '%s חודשים' },
    w: { one: 'שבוע', two: 'שבועיים', other: '%s שבועות' },
    d: { one: 'יום %s', two: 'יומיים', many: '%s ימים', other: '%s ימים' },
    h: { one: 'שעה', two: 'שעתיים', many: '%s שעות', other: '%s שעות' },
    m: { one: 'דקה', two: '%s דקות', many: '%s דקות', other: '%s דקות' },
    s: { one: 'שניה', two: '%s שניות', many: '%s שניות', other: '%s שניות' },
  },
  justNow: 'הרגע',
  yesterday: 'אתמול',
  today: 'היום',
  tomorrow: 'מחר',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: '‎D בMMMM YYYY', end: '‎D בMMMM YYYY' },
    'yl-1': { start: '‎D בMMMM', end: '‎D בMMMM YYYY' },
    ml: { start: '‎D בMMMM', end: '‎D בMMMM' },
    'ml-1': { start: '‎D', end: '‎D בMMMM YYYY' },
    dl: { start: '‎D', end: '‎D בMMMM' },
    y: { start: '‎D בYYYY MMM', end: '‎D בYYYY MMM' },
    'y-1': { start: '‎D בMMM', end: '‎D בYYYY MMM' },
    m: { start: '‎D בMMM', end: '‎D בMMM' },
    'm-1': { start: '‎D', end: '‎D בYYYY MMM' },
    d: { start: '‎D', end: '‎D בMMM' },
    Y: { start: 'dddd, D בYYYY MMM', end: 'dddd, D בYYYY MMM' },
    'Y-1': { start: 'dddd, D בMMM', end: 'dddd, D בYYYY MMM' },
    M: { start: 'dddd, D בMMM', end: 'dddd, D בMMM' },
    D: { start: 'dddd, D בMMM', end: 'dddd, D בMMM' },
    yt: { start: '‎D בYYYY MMM בשעה HH:mm', end: '‎D בYYYY MMM בשעה HH:mm' },
    mt: { start: '‎D בMMM בשעה HH:mm', end: '‎D בMMM בשעה HH:mm' },
    dt: { start: '‎D בשעה HH:mm', end: '‎D בMMM בשעה HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: '‎D בYYYY MMM בשעה HH:mm', end: '‎D בYYYY MMM בשעה HH:mm ([GMT]Z[‎])' },
    'mt+to': { start: '‎D בMMM בשעה HH:mm', end: '‎D בMMM בשעה HH:mm ([GMT]Z[‎])' },
    'dt+to': { start: '‎D בשעה HH:mm', end: '‎D בMMM בשעה HH:mm ([GMT]Z[‎])' },
    't+to': { start: '‎HH:mm', end: '‎HH:mm ([GMT]Z[‎])' },
  },
};
const localeName: LocaleName = 'he';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'לפנה"צ' : 'לפנה"צ';
    } else {
      return isLowerCase ? 'אחה"צ' : 'אחה"צ';
    }
  },
};
